import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-org-chart',
    templateUrl: './org-chart.component.html',
    styleUrls: ['./org-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrgChartComponent {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  baseUrls: any = {};
  headerData: any = {};
  rowData: any = {};
  filterParams: any = {};

  crudLoading = false;
  questions: any[] = [];

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      const parsed = typeof baseUrls === 'string' ? safeJsonInput<any>(baseUrls, null, 'org-chart.parse1') : baseUrls;
      if (parsed && Object.keys(parsed).length > 0) {
        this.baseUrls = parsed;
      }
    } catch (e) {
      console.log('Base URLs input not yet stable.');
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      const parsed = typeof headerData === 'string' ? safeJsonInput<any>(headerData, null, 'org-chart.parse2') : headerData;
      if (parsed && Object.keys(parsed).length > 0) {
        this.headerData = parsed;
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      this.rowData = typeof rowData === 'string' ? safeJsonInput<any>(rowData, null, 'org-chart.parse3') : rowData || {};
      const sourceQuestions = this.rowData?.questions;
      this.questions = Array.isArray(sourceQuestions) ? [...sourceQuestions] : [];
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      const parsed = typeof filterParams === 'string' ? safeJsonInput<any>(filterParams, null, 'org-chart.parse4') : filterParams;
      if (parsed && Object.keys(parsed).length > 0) {
        this.filterParams = parsed;
      }
    } catch (e) {
      console.log('Filter params input not yet stable.');
    }
  }

  save(): void {
    this.requestGridUpdate.emit('refresh');
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
